<template>
  <v-row>
    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Proyectos destacados:</h3>

            <v-switch
              v-model="enable_featured_projects_landing"
              label="Habilitar proyectos destacados"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-divider></v-divider>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h3>Título de la Sección:</h3>
            <v-text-field
              v-model="title_featured_projects"
              :disabled="!enable_featured_projects_landing"
              :counter="100"
              :maxLength="100"
              class="mt-4"
              label="Título para esta sección"
              outlined
            ></v-text-field>
          </v-col>

                    <v-col 
            cols="12">
            <v-data-table
              :disabled="!enable_featured_projects_landing"
              :headers="headers"
              :items="entrepreneurships_list"
              :items-per-page="50"
                  :footer-props="{
                    'items-per-page-options': [30, 40, 50, 100, 200],
                    'items-per-page-text':'Filas por página',
                  }"
              mobile="true"
            >

              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="mx-2"
                  fab
                  :dark="enable_featured_projects_landing"
                  x-small
                  color="error"
                  :disabled="!enable_featured_projects_landing"
                  @click="deleteEntreprenship(item)"
                >
                  <v-icon dark small>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" class="d-flex align-center justify-center mb-8">
            <v-btn
              color="primary"
              :disabled="!enable_featured_projects_landing"
              @click="getEditions()">
              Agregar proyecto
            </v-btn>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateTextLanding()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading_entrepreneurship"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="add_entrepreneurship_dialog"
      width="640">
      <v-card>
        <v-card-title class="text-h6">
          Proyectos
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col
              cols="12"
            >
              <v-select
                v-model="edition_id"
                :items="editions"
                label="Emprendimientos"
                outlined
                item-text="name"
                item-value="id"
              ></v-select>

              <v-select
                v-model="entrepreneurship_selected"
                :items="entrepreneurships"
                label="Emprendimientos"
                outlined
                item-text="title"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="add_entrepreneurship_dialog=!add_entrepreneurship_dialog"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!entrepreneurship_selected"
            @click="addEntrepreneurshipList()"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'customizationFeaturedEntrepreneurshipsSection',
    data: () => ({
      loading:true,
      loading_update: false,
      loading_entrepreneurship:false,
      add_entrepreneurship_dialog:false,
      landing: [],

      enable_featured_projects_landing:false,
      title_featured_projects:'',
      
      edition_id: null,
      editions: [],
      entrepreneurships: [],
      entrepreneurship_selected: null,

      entrepreneurships_list: [],
      entrepreneurship: null,

      error:false,
      errors:[],

      headers: [
        {
          text: '# ID',
          align: 'center',
          filterable: true,
          value: 'id',
          width:'5%'
        },
        {
          text: 'Emprendimiento',
          align: 'start',
          filterable: true,
          value: 'title',
          width:'30%'
        },
        { 
          text: 'Acciones',
          align: 'center',
          filterable: false,
          value: 'actions',
          width:'10%'
        },
      ]
    }),
    watch: {
      edition_id() {
        this.getEntrepreneurships();
      },
    },
    methods:{
      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing
          this.entrepreneurships_list = response.data.data.landing.entrepreneurships
          this.enable_featured_projects_landing = (this.landing.enable_featured_projects_landing)?true:false
          this.title_featured_projects = (this.landing.title_featured_projects)?this.landing.title_featured_projects:''
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async getEditions(){
        this.loading_entrepreneurship = true
        await axios.get('admin/editions').then(response =>{
          this.editions = response.data

          if(this.editions.length>0&&!this.edition_id){
            this.edition_id = this.editions[0].id
          }

          this.getEntrepreneurships()
        }).catch(error => {
          this.loading_entrepreneurship=false
          console.log(error);
        })
      },

      async getEntrepreneurships(){
        this.loading_entrepreneurship = true
        await axios.get('admin/edition/'+this.edition_id+'/entrepreneurships').then(response =>{
          this.entrepreneurships = response.data.data.entrepreneurships

          if(this.entrepreneurships.length>0){
            this.entrepreneurship_selected = this.entrepreneurships[0].id
          }

          this.loading_entrepreneurship = false
          this.add_entrepreneurship_dialog = true
        }).catch(error => {
          this.loading_entrepreneurship=false
          console.log(error);
        })
      },

      async addEntrepreneurshipList(){
        this.add_entrepreneurship_dialog = false
        this.loading_entrepreneurship = true
        await axios.get('admin/entrepreneurships/'+this.entrepreneurship_selected).then(response =>{
          this.entrepreneurship = response.data.data.entrepreneurship
          this.loading_entrepreneurship = false

          this.entrepreneurships_list.push(this.entrepreneurship)
          this.entrepreneurship_selected = null
          this.add_entrepreneurship_dialog = false
          
        }).catch(error => {
          this.loading_entrepreneurship=false
          console.log(error);
        })
      },

      deleteEntreprenship(item){
        this.entrepreneurships_list = this.entrepreneurships_list.filter(elemento => elemento.id !== item.id);      
      },

      async updateTextLanding(){
        this.loading_update=true
        let formData= new FormData()
        
        formData.append('enable_featured_projects_landing', (this.enable_featured_projects_landing)?1:0)
        
        if(this.title_featured_projects!=null){
          formData.append('title_featured_projects', this.title_featured_projects)
        }

        let entrepreneurships_list_aux = []
        this.entrepreneurships_list.forEach(element => {
          entrepreneurships_list_aux.push(element.id)
        });
        formData.append('entrepreneurships_list', JSON.stringify(entrepreneurships_list_aux))
        
        try {
          await axios({
            method: 'post',
            url: 'admin/landing/featured-projects-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      }
    },
    created(){
      Promise.all([
        this.getCustomization()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    }
  }
</script>